import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';

import { Text, Input, Select } from 'v3/components';

import Card, { DefaultLoadingBodyComponent } from 'v3/components/Card';

import api, { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';

import {
  fetchCities,
  fetchBrands,
  fetchVehicleColors
} from 'utils/fetches';

export default function GeneralDate({
  setData,
  data,
  fildsDisabled,
  errors
}) {

  const snackbar = useSnackbar();

  const [vehicles, setVehicles] = useState({});
  const [axisOptions, setAxisOptions] = useState({});
  const [allAxisOptions, setAllAxisOptions] = useState([]);
  const [colors, setColors] = useState([]);
  const [fuels, setFuels] = useState();

  const [uniqueAxis, setUniqueAxis] = useState(false);
  const [modelOptions, setModelOptions] = useState([]);

  async function fetchVehicles() {
    try {
      const response = await api.get('vehicle-types', {
        params: { app: true },
      });

      setVehicles(
        response.data?.filter(
          item => item.name !== 'Semi Reboque' && item.name !== 'Dolly'
        )
      );
    } catch (error) {
      // handle exception
      setVehicles({});
    }
  }

  async function fetchFuels() {
    try {
      const response = await api.get('fuel');
      setFuels(response.data);

    } catch (error) {
      // handle exception
      setFuels([]);
    }
  }

  useEffect(() => {
    fetchFuels();
    fetchVehicles();
    fetchVehicleColors().then(setColors);
  }, []);

  useEffect(() => {
    async function fetchVehicleAxis() {
      try {
        const response = await api.get('vehicle-axe', {
          params: { app: true },
        });
        setAllAxisOptions(response.data);
        setAxisOptions(response.data);
        if (data?.type?.id === 18 || !data?.type?.id) {
          setUniqueAxis(false);
        } else if (data?.type?.id === 1) {
          setUniqueAxis(false);
          const newTraction =
            data?.traction !== null && data?.traction?.id <= 3
              ? null
              : data?.traction;
          setData({ ...data, traction: newTraction, implement: null, implements: null });
          setAxisOptions(response.data.filter(axe => axe?.id > 3));
        } else if (data?.type?.id === 4) {
          setUniqueAxis(false);
          const newTraction =
            data?.traction !== null &&
            (data?.traction?.id === 1 || data?.traction?.id > 3)
              ? null
              : data?.traction;
          setData({ ...data, traction: newTraction, implement: null, implements: null });
          setAxisOptions(response.data.filter(axe => axe?.id > 1 && axe?.id < 4));
        } else if (
          data?.type?.id === 3 ||
          data?.type?.id === 5 ||
          data?.type?.id === 11 ||
          data?.type?.id === 12
        ) {
          setUniqueAxis(true);
          setData({ ...data, traction: response.data[0], implement: null, implements: null });
          setAxisOptions([response.data[0]]);
        } else {
          setUniqueAxis(false);
          setData({ ...data, implement: null, implements: null });
          setAxisOptions(response.data);
        }
      } catch (error) {
        // handle exception
      }
    }

    if (allAxisOptions.length === 0) {
      fetchVehicleAxis();
    } else if (data?.type?.id === 18 || !data?.type?.id) {
      setUniqueAxis(false);
      setAxisOptions(allAxisOptions);
    } else if (data?.type?.id === 1) {
      setUniqueAxis(false);
      const newTraction =
        data?.traction !== null && data?.traction?.id <= 3
          ? null
          : data?.traction;
      setData({ ...data, traction: newTraction, implement: null, implements: null });
      setAxisOptions(allAxisOptions.filter(axe => axe?.id > 3));
    } else if (data?.type?.id === 4) {
      setUniqueAxis(false);
      const newTraction =
        data?.traction !== null &&
        (data?.traction?.id === 1 || data?.traction?.id > 3)
          ? null
          : data?.traction;
      setData({ ...data, traction: newTraction, implement: null, implements: null });
      setAxisOptions(allAxisOptions.filter(axe => axe?.id > 1 && axe?.id < 4));
    } else if (
      data?.type?.id === 3 ||
      data?.type?.id === 5 ||
      data?.type?.id === 11 ||
      data?.type?.id === 12
    ) {
      setUniqueAxis(true);
      setData({ ...data, traction: allAxisOptions[0], implement: null, implements: null });
      setAxisOptions([allAxisOptions[0]]);
    } else {
      setUniqueAxis(false);
      setData({ ...data, implement: null, implements: null });
      setAxisOptions(allAxisOptions);
    }
  }, [data?.type]);


  async function fetchModels(search) {
    if (data.brand?.id) {
      try {

        const { data } = await cooperplaceApi.get(`vehicles/manufacturers/${data.brand.id}/models`, {
          params: { search }
        });

        return data?.data;
      } catch (error) {
        return [];
      }
    }
    snackbar.show(<Text>Selecione uma marca primeiro</Text>, { type: `error` });
    return [];
  }

  async function handleChangeBrand(value) {
    try {
      if (value?.id) {
        const { data } = await cooperplaceApi.get(`vehicles/manufacturers/${value.id}/models`);
        const response = data?.data
        setModelOptions(response);
      } else {
        setModelOptions([]);
      }
    } catch (error) {
      if (value?.id)
        snackbar.show(<Text>Erro ao buscar modelos</Text>, { type: 'error' });
    }

    setData({ ...data, brand: value, model: null });
  }

  return (
    <Card
      LoadingBodyComponent={() => (
        <DefaultLoadingBodyComponent linesCount={1} perLine={1} />
      )}
      header={
        <Text color="#464E5F" type="header">
          Dados gerais
        </Text>
      }
    >
      <Row className="form">
        <Col md={6} xs={12}>
          <Input
            label="Placa *"
            value={data?.plate}
            onChange={event => setData({ ...data, plate: event.target.value.toUpperCase() })
            }
            error={errors?.plate}
            disabled={fildsDisabled}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Renavam *"
            type="number"
            value={data?.renavam}
            onChange={event => setData({ ...data, renavam: event.target.value })}
            disabled={fildsDisabled}
            error={errors?.renavam}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Ano do modelo *"
            type='year'
            value={data?.yearModel}
            onChange={event => setData({ ...data, yearModel: event.target.value })}
            disabled={fildsDisabled}
            error={errors?.yearModel}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Ano de fabricação *"
            type='year'
            value={data?.yearManufacture}
            onChange={event => setData({ ...data, yearManufacture: event.target.value })}
            disabled={fildsDisabled}
            error={errors?.yearManufacture}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="CRLV *"
            type="number"
            value={data?.crlv}
            onChange={event => setData({ ...data, crlv: event.target.value })}
            disabled={fildsDisabled}
            error={errors?.crlv}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select
            label="Cor *"
            options={colors}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.color}
            onChange={value => setData({ ...data, color: value })}
            isDisabled={fildsDisabled}
            error={errors?.color}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select
            label="Tipo do veículo *"
            options={vehicles}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.type}
            onChange={value => setData({ ...data, type: value })}
            isDisabled={fildsDisabled}
            error={errors?.type}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select
            label={'Tração *'}
            isDisabled={uniqueAxis}
            options={axisOptions}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.traction}
            onChange={value => setData({ ...data, traction: value })}
            error={errors?.traction}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Eixos *"
            type="number"
            value={data?.axis}
            onChange={event => setData({ ...data, axis: event.target.value })}
            disabled={fildsDisabled}
            error={errors?.axis}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select.Async
            label="Marca *"
            onSearch={fetchBrands}
            value={data?.brand}
            onChange={handleChangeBrand}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            error={errors?.brand}
            removeInputMin
            isDisabled={fildsDisabled}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select.Async
            label="Modelo *"
            onSearch={fetchModels}
            value={data?.model}
            options={modelOptions}
            onChange={value => setData({ ...data, model: value })}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            isDisabled={fildsDisabled}
            error={errors?.model}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Chassi *"
            value={data?.chassi}
            onChange={event => setData({ ...data, chassi: event.target.value })}
            disabled={fildsDisabled}
            error={errors?.chassi}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select
            label="Combustível *"
            options={fuels}
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            value={data?.fuel}
            onChange={value => setData({ ...data, fuel: value })}
            error={errors?.fuel}
            isDisabled={fildsDisabled}
          />
        </Col>
        <Col md={6} xs={12}>
          <Select.Async
            label="Cidade *"
            onSearch={fetchCities}
            value={data?.city}
            onChange={value => setData({ ...data, city: value })}
            getOptionLabel={option =>
              `${option.name}, ${option?.province?.uf || '--'}`
            }
            getOptionValue={option => option.id}
            isDisabled={fildsDisabled}
            error={errors?.city}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Cronotacógrafo *"
            type="number"
            value={data?.chronotachographNumber}
            onChange={event => setData({ ...data, chronotachographNumber: event.target.value })}
            error={errors?.chronotachographNumber}
          />
        </Col>
        <Col md={6} xs={12}>
          <Input
            label="Validade cronotacógrafo *"
            type="date"
            value={data?.chronotachographExpDate}
            onChange={event => setData({ ...data, chronotachographExpDate: event.target.value })}
            error={errors?.chronotachographExpDate}
          />
        </Col>
      </Row>
    </Card>
  );
}
